import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ViewCountryHeadCountWrapper } from "./ViewCountryDialogStyled";
import Checkbox from "@mui/material/Checkbox";
import { Troubleshoot } from "@mui/icons-material";
import { Box, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TableSortLabel from "@mui/material/TableSortLabel";
const ViewCountryDialog = ({
  headers,
  rows,
  open,
  close,
  remove,
  add,
  handleChange,
  countries,
  handleTextboxChange,
  handleSelectChange,
  headcountError,
  countryError,
  newCountry,
  loadingState
}) => {
  const idsToRemove = new Set(rows.map(obj => obj.countryName));
  countries= countries.filter(obj => !idsToRemove.has(obj.countryName));
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("countryName");
  const createSortHandler = (property) => (event) => {
    setOrder(order == "asc" ? "desc" : "asc");
    setOrderBy(property);
  };
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  return (
    <>
      <ViewCountryHeadCountWrapper className={loadingState ? "content-pointer-event-none" : ""}
        onClose={close}
        open={open}
        scroll='paper'
        fullWidth={true}
      >
        <DialogContent class="customDialog"  >
          {headers.length > 0 && rows.length > 0 && (
            <Table stickyHeader  aria-label="simple table">
              <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
                <TableRow>
                  {headers.map((cell) => (
                    <TableCell key={cell.id}>
                      {cell.label}
                      {
                        <TableSortLabel
                          active={orderBy === cell.id}
                          direction={orderBy === cell.id ? order : "asc"}
                          onClick={createSortHandler(cell.id)}
                        ></TableSortLabel>
                      }
                    </TableCell>
                  ))}
                </TableRow>
                {/* <TableRow >
                  <TableCell align="right" className="addRow">
                    <div className="newRow">
                    <div className="inputdropdownBox">
                      <FormControl className="customDropdown">
                        <Select
                         title={newCountry.country>0?countries.find(x=>x.id===newCountry.country)?.countryName:""}
                          defaultValue={0}
                          size="small"
                          value={newCountry.country}
                          onChange={(e) => handleSelectChange(e)}
                        >
                          <MenuItem value={0} disabled>
                            Select Country
                          </MenuItem>
                          {countries.map((option) => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                            >
                              {option.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box>
                        {countryError && (
                          <span className="error">{countryError}</span>
                        )}
                      </Box>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="right" className="addRow">
                    <div className="newRow">
                      <div className="inputBox">
                        <TextField
                          size="small"
                          placeholder="Enter head count"
                          name="headcount"
                          inputProps={{ maxLength: 10 }}
                          value={newCountry.headcount}
                          onChange={(e) => handleTextboxChange(e)}
                        />
                        <Box>
                          {headcountError && (
                            <span className="error">{headcountError}</span>
                          )}
                        </Box>
                      </div>
                      <div className="buttonTab">
                        <Button
                          variant="contained"
                          className="addbutton"
                          onClick={add}
                        >
                          Add +
                        </Button>
                      </div>
                    </div>
                  </TableCell>
                </TableRow> */}
              </TableHead>

              <TableBody sx={{ border: "1px solid #1B4A83" }}>
               
                {stableSort(rows, getComparator(order, orderBy)).map(
                  (row, index) => (
                    <TableRow key={index}>
                      {headers.map((cell) => (
                        <TableCell key={cell.id} align="right">
                          {cell.id === "countryName" && (
                            <Checkbox
                              value={row?.countryId}
                              checked={row?.isChecked}
                              onChange={handleChange}
                            />
                          )}{" "}
                          {isNaN(row[cell.id])
                            ? row[cell.id]
                            : row[cell.id]?.toLocaleString()}
                        </TableCell>
                      ))}
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          )}
        </DialogContent>
        <DialogActions className="dialogbutton">
          <Button variant="outlined" className="rightButton" onClick={close}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className="confirmButton"
            onClick={remove}
          >
            Remove
          </Button>
        </DialogActions>
      </ViewCountryHeadCountWrapper>
    </>
  );
};

export default ViewCountryDialog;
